export const ratingFilterTagPrefix = 'f-';
export const ratingDetailPagePath = '/rating/';
